import React from "react";
import { Container, Nav, Navbar, NavDropdown } from "react-bootstrap";

export const NavBar = () => {
  return (
    <Navbar expand="lg" className="bg-body-tertiary">
      <Container>
        <Navbar.Brand href="/telco" className="mr-auto">
          <img
            src={require("./icon-1000px.webp")}
            width="80"
            height="80"
            className="d-inline-block align-top"
            alt="demo bank logo"
          />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav>
            <Nav.Link
              href="/telco"
              className="mx-2"
              style={{ margin: "0 10px", color: "black" }}
            >
              Home
            </Nav.Link>
            <NavDropdown
              title="Shop"
              id="basic-nav-dropdown"
              style={{ margin: "0 10px" }}
            >
              <NavDropdown.Item href="#action/1.1">
                Phones and Tablets
              </NavDropdown.Item>
              <NavDropdown.Item href="#action/1.2">
                Pay monthly SIM
              </NavDropdown.Item>
              <NavDropdown.Item href="#action/1.3">
                <b>Pay as you go SIM</b>
              </NavDropdown.Item>
              <NavDropdown.Item href="#action/1.4">Broadband</NavDropdown.Item>
              <NavDropdown.Item href="#action/1.5">
                Latest Deals
              </NavDropdown.Item>
            </NavDropdown>

            <NavDropdown
              title="Why Telco"
              id="basic-nav-dropdown"
              style={{ margin: "0 10px" }}
            >
              <NavDropdown.Item href="#action/2.1">
                Our Best Network
              </NavDropdown.Item>
              <NavDropdown.Item href="#action/2.2">
                News Center
              </NavDropdown.Item>
              <NavDropdown.Item href="#action/2.3">5G</NavDropdown.Item>
              <NavDropdown.Item href="#action/2.4">
                Outstanding Service
              </NavDropdown.Item>
            </NavDropdown>

            <NavDropdown
              title="My Telco"
              id="basic-nav-dropdown"
              style={{ margin: "0 10px" }}
            >
              <NavDropdown.Item href="#action/3.1">
                Billing and Payments
              </NavDropdown.Item>
              <NavDropdown.Item href="#action/3.2">
                Change my plan
              </NavDropdown.Item>
              <NavDropdown.Item href="#action/3.3">Upgrade</NavDropdown.Item>
              <NavDropdown.Item href="#action/3.4">
                Account Settings
              </NavDropdown.Item>
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};
